import { styled, Box, IconButton, Typography } from "@mui/material";
import { dumontColors } from "../../colors";

export const NavItem = styled(Box)<{ isActive: boolean }>(({ isActive }) => ({
  width: 60,
  height: 46,
  backgroundColor: isActive ? "rgba(0, 164, 159, 0.05)" : "transparent",
  border: isActive ? "1px solid rgba(0, 164, 159, 0.4)" : "1px solid transparent",
  borderRadius: "6px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxSizing: "border-box",
  "&:hover": {
    backgroundColor: dumontColors.primaryLight,
  },
}));

export const NavItemText = styled(Typography)<{ isActive: boolean }>(({ isActive }) => ({
  fontSize: 11,
  fontWeight: 600,
  color: isActive ? dumontColors.primary : dumontColors.textTertiary,
  textAlign: "center",
}));

export const HelpButton = styled(IconButton)({
  width: 40,
  height: 40,
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(0, 164, 159, 0.05)",
  },
});
